
















































































import { Component, Prop, Emit } from 'vue-property-decorator';
import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import {mixins} from 'vue-class-component';
import {AclMixin} from '@/components/acl/acl-mixin';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component({
  components: {
    WorkspaceSelect,
    NoTagFound
  }
})
export default class FlowSettings extends mixins<PlanLimitsMixin,AclMixin>(PlanLimitsMixin,AclMixin) {
  @Prop()
  form: any;

  @Prop({ default: false })
  disabledWorkspace: boolean;

  @Prop()
  workspacesList: any;

  @Emit('change-workspace')
  onChangeWorkspace() {}

  @Emit('change-country')
  onCountryChange() {}

  @Prop({ default: () => {} })
  errorsDict: any;

  get nameDescriptionCountryName() {
    return this.countryName || this.t('Global');
  }

  get nameDescriptionName() {
    return this.form.name || this.t('None');
  }

  get nameDescription() {
    return `${this.nameDescriptionCountryName} - ${this.nameDescriptionName}`;
  }

  get countryListPlusGlobal() {
    return this.$store.getters.countryListPlusGlobal;
  }

  get countryName(){
    return this.form.countryId && this.countryListPlusGlobal.find((e: any) => e.id === this.form.countryId).name;
  }

  get showPlanLimitsWarning_tags() {
    return this.form.tags?.length && this.hasPlanLimitsRestriction('tagsFlows')
  }

  clearTags(){
    this.form.tags = []
  }
}
